// extracted by mini-css-extract-plugin
export var badge = "_sr-4";
export var selected = "_sr-1";
export var selectedOverlay = "_sr-5";
export var thumbnailButton = "_sr-0";
export var thumbnailFallback = "_sr-3";
export var thumbnailImage = "_sr-2";